import type React from 'react';
import { useEffect } from 'react';
import { X } from 'lucide-react';
import {
  amex,
  boleto,
  elo,
  master,
  pix,
  visa,
} from 'src/assets/images/payments-img';

interface PaymentMethodsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PaymentMethodsModal: React.FC<PaymentMethodsModalProps> = ({
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const cardMethods = [
    { name: 'Amex', image: amex },
    { name: 'Elo', image: elo },
    { name: 'Master', image: master },
    { name: 'Visa', image: visa },
  ];

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto">
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-lg w-full max-w-2xl mx-4 my-8 max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between z-10">
          <h2 className="text-xl font-semibold">
            Meios de pagamento para este produto
          </h2>
          <button
            onClick={onClose}
            className="text-blue-600 hover:text-blue-700 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="pb-6 border-b">
            <h3 className="text-base font-semibold mb-2">Cartão de crédito</h3>
            <p className="text-sm text-gray-600 mb-4">Em até 12x</p>

            <div className="grid grid-cols-4 gap-4">
              {cardMethods.map((method) => (
                <div
                  key={method.name}
                  className="flex items-center justify-center"
                >
                  <img
                    src={method.image}
                    alt={method.name}
                    className="w-16 h-16 object-contain"
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="pb-6 border-b">
            <h3 className="text-base font-semibold mb-2">PIX</h3>
            <p className="text-sm text-gray-600 mb-4">Aprovação imediata</p>

            <div className="flex items-center justify-start">
              <img src={pix} alt="PIX" className="w-16 h-16 object-contain" />
            </div>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-2">Boleto bancário</h3>
            <p className="text-sm text-gray-600 mb-4">
              Aprovado após confirmação bancária, que pode levar de 1 a 3 dias
              úteis
            </p>

            <div className="flex items-center justify-start">
              <img
                src={boleto}
                alt="Boleto"
                className="w-16 h-16 object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
